import { VALIDATION_MESSAGES } from '../core/ValidationMessages';
export function validateCompetenceFormat(competence) {
    const competenceRegex = /^\d{4}-\d{2}$/;
    if (!competenceRegex.test(competence)) {
        return {
            isValid: false,
            errors: [VALIDATION_MESSAGES.COMPETENCE_FORMAT],
        };
    }
    return { isValid: true, errors: [] };
}
export function validateDateFormat(dateString) {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateString)) {
        return {
            isValid: false,
            errors: [VALIDATION_MESSAGES.DATE_FORMAT],
        };
    }
    return { isValid: true, errors: [] };
}
export function validateDateNotInPast(dateString, fieldName = 'Date') {
    try {
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
        const dateParts = dateRegex.exec(dateString);
        if (!dateParts) {
            return {
                isValid: false,
                errors: [VALIDATION_MESSAGES.DATE_INVALID(fieldName)],
            };
        }
        const year = parseInt(dateParts[1], 10);
        const month = parseInt(dateParts[2], 10) - 1;
        const day = parseInt(dateParts[3], 10);
        const inputDate = new Date(year, month, day);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (isNaN(inputDate.getTime())) {
            return {
                isValid: false,
                errors: [VALIDATION_MESSAGES.DATE_INVALID(fieldName)],
            };
        }
        if (inputDate < today) {
            return {
                isValid: false,
                errors: [VALIDATION_MESSAGES.DATE_IN_PAST(fieldName)],
            };
        }
        return { isValid: true, errors: [] };
    }
    catch {
        return {
            isValid: false,
            errors: [VALIDATION_MESSAGES.DATE_INVALID(fieldName)],
        };
    }
}
